import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AddexpensetypeComponent } from '../../expensetype/addexpensetype/addexpensetype.component';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AddexpensedetailComponent } from '../addexpensedetail/addexpensedetail.component';
@Component({
  selector: 'app-addexpense',
  templateUrl: './addexpense.component.html',
  styleUrls: ['./addexpense.component.css']
})
export class AddexpenseComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  ispartyaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  expensemainColl: any = [];

  expenseBO: any = {}
  partyColl: any = [];
  paymenttermsColl: any = [];
  paymentmodeColl: any = [];

  expensedetailscoll: any = [];

  ismanualclose: boolean;

  isexpensetypeaddmode: boolean = false;

  expensetypeColl: any = [];

  amount: number = 0;
  totalamount: number = 0;

  discounttype: string = "";



  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  expenseform = new FormGroup({
    expenseid: new FormControl(0),
    expenseno: new FormControl('', Validators.required),
    expensedate: new FormControl(null, Validators.required),
    expenseamt: new FormControl(null),
    description: new FormControl(''),
    refno: new FormControl(''),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Expense";

  gridfocusrow: number = -1;

  @Input() expenseid: number = 0
  @Input() filterpartyid: number = null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() ptype: String = "S";
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();
  grandtotal: number;

  currencyMask:any="";

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

      this.currencyMask=this.loginService.fngetDecimalPlaces()
      
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.expenseform.reset();
      this.fnInitializeForm();

      if (this.expenseid > 0) {
        this.fngetExpense();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fnGetParty();
      this.fnGetExpenseType();


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }




  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.expenseid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isexpensetypeaddmode = this.loginService.fnCheckUserRoleAction("Expensetype", 'CREATE')
    this.ispartyaddmode = this.loginService.fnCheckUserRoleAction("Supplier", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.expenseform.setValue({
      expenseid: 0,
      expenseno: 'NEW',
      expensedate: new Date(),
      expenseamt: null,
      description: null,
      refno: '',
      inactive: false,
    })
  }

  //Get 
  fngetExpense() {

    var data = {
      'expenseid': this.expenseid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getExpense(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.expensemainColl = result[0];

          var editdata = this.expensemainColl[0];
          this.expenseBO = editdata;
          this.fnEditMode(editdata);

          this.expensedetailscoll = result[1];
          ////console.log(this.expensedetailscoll)

          if (this.expensedetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcsSummaryTotal();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.expensedetailscoll) {
      if (row.expensetypeid > 0) {
        _detailscheck = true;
      }
    }

    if (!_detailscheck) {
      this.errtxt = "Expense Details cannot be empty"
      this.expenseform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      for (let row of this.expensedetailscoll) {

        if (row.expensetypeid > 0 && this.loginService.fnCheckZeroDetcimal(row.amount) === 0) {
          this.errtxt = "Amount is cannot be empty"
          this.expenseform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.expenseform.get('inactive')) {
      this.expenseform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.expenseform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'expenseid': this.expenseid,
          'expenseno': this.expenseform.get('expenseno').value,
          'expensedate': this.fnFormatDatetime(this.expenseform.get('expensedate').value),
          'expenseamt': this.expenseform.get('expenseamt').value,
          'description': this.expenseform.get('description').value,
          'refno': this.expenseform.get('refno').value,
          'inactive': this.expenseform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'expensedetailscoll': this.expensedetailscoll,
        }

        if (this.expenseform.get('expenseid').value > 0) {

          this.fnSetExpense(data);
        }
        else {

          this.fnInsertExpense(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertExpense(data) {

    this.appService.fnInsertExpense(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Expense has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.expenseno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].expenseid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetExpense(data) {

    this.appService.fnSetExpense(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Expense has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.expenseid, data.expenseno);

          this.fnEditFormEdit(this.expenseid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.expensedate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.expensedate));


    this.expenseform.setValue({

      expenseid: deptBO.expenseid,
      expenseno: deptBO.expenseno,
      expensedate: deptBO.expensedate,
      expenseamt: deptBO.expenseamt,
      description: deptBO.description,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.expenseid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetExpenseType() {
    this.isLoadingResult = true;

    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getExpensetype(data)
      .subscribe(
        (res) => {
          this.expensetypeColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadExpenseType(index) {


    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getExpensetype(data)
      .subscribe(
        (res) => {
          this.fnChangeExpenseType(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnGetParty() {
    var data = {
      'partyid': 0,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnChangeExpenseType(index) {

    var _expensetypename = "", _partyid = 0;

    for (let abo of this.expensetypeColl) {
      if (this.expensedetailscoll[index].expensetypeid === abo.expensetypeid) {
        _expensetypename = abo.expensetypename;
      }
    }
    this.expensedetailscoll[index].expensetypename = _expensetypename;
  }
  fnChangeParty(index) {

    var _partyname = "";

    for (let abo of this.partyColl) {
      if (this.expensedetailscoll[index].partyid === abo.partyid) {
        _partyname = abo.partyname;
      }
    }
    this.expensedetailscoll[index].partyname = _partyname;
  }


  fnCalcDetails() {

    for (let row of this.expensedetailscoll) {

      this.grandtotal = this.grandtotal + Number(row.amount)

    }

  }

  // fnCalcDetails() {

  //   for (let row of this.expensedetailscoll) {
  //     row.subtotal = row.qty * row.unitprice;
  //     this.subtotal = this.subtotal + Number(row.subtotal)



  //   }
  //   this.fnCalcsSummaryTotal()
  // }



  fnCalcsSummaryTotal() {

    this.totalamount = 0;


    for (let row of this.expensedetailscoll) {

      this.totalamount = Number(this.fnConvertDecimal(this.totalamount)) + Number(this.fnConvertDecimal(row.amount))
    }
    this.expenseform.patchValue({ expenseamt: this.totalamount })
  }




  fnDeleteexpenseConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.expensedetailscoll.splice(index, 1)
            if (this.expensedetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            // this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  // fnChangeRawmaterial(index) {

  //   var _prodname = "", _unitprice = 0;

  //   for (let abo of this.rawmaterialColl) {
  //     if (this.expensedetailscoll[index].rawmaterialid === abo.rawmaterialid) {
  //       _prodname = abo.rawmaterialname;
  //       _unitprice = abo.expenseprice;


  //     }
  //   }
  //   this.expensedetailscoll[index].rawmaterialname = _prodname;
  //   this.expensedetailscoll[index].unitprice = _unitprice;



  // }


  fnSetFirstRowItem() {
    if (this.expensedetailscoll.length > 0) {
      if (!this.expensedetailscoll[this.expensedetailscoll.length - 1].expensetypeid) {
        return
      }
    }

    var data = {
      expensedetailsid: 0,
      expenseid: 0,
      expensetypeid: null,
      expensetypename: '',
      partyid: null,
      partyname: '',
      descr: '',
      amount: 0,

    }

    this.expensedetailscoll.push(data)
    //console.log(this.expensedetailscoll)

  }

  fnGetFirstRowItem() {

    var data = {
      expensedetailsid: null,
      expenseid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: null,
      unitprice: null,
      subtotal: null,
      uomid: null,
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal: null
    }

    return data;

  }
  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.expensedetailscoll.length > 0) {

      if (this.expensedetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //AddParty
  private fnAddParty() {

    const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l' });
    modalRef.componentInstance.ptype = this.ptype

    if (modalRef.componentInstance.ptype === 'C') {
      modalRef.componentInstance.formname = 'Customer'
    }
    else if (modalRef.componentInstance.ptype === 'S') {
      modalRef.componentInstance.formname = 'Supplier'
    }
    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetParty();

      if (receivedEntry > 0) {
        this.expenseform.patchValue({ partyid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddExpenseType(index) {

    const modalRef = this.productFindService.open(AddexpensetypeComponent, { size: <any>'m' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetExpenseType();

      if (receivedEntry > 0) {
        this.expensedetailscoll[index].expensetypeid = receivedEntry
      }
      this.fnReLoadExpenseType(index);

    });
  }
  //Print
  // private fnPrintexpense() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.expenseid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.expenseid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  fnAddExpenseDetails() {

    const modalRef = this.productFindService.open(AddexpensedetailComponent, { size: <any>'l' });
    modalRef.componentInstance.expensedetailsBO=this.fnGetFirstRowItem()
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry.checkstatus === "DONE") {
        this.fnSetFirstRowItem()
        this.expensedetailscoll[this.expensedetailscoll.length - 1] = receivedEntry.data;
        this.fnCalcDetails()
      }

    });
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
